<template>
  <div
    :class="active ? 'bg-surface-user-blue text-headline-new' : 'text-label'"
    class="flex w-full cursor-pointer justify-start rounded-4 py-2 text-sm font-medium hover:bg-surface-user-blue"
    data-cy="side-menu-item"
  >
    <slot name="content">
      <div
        v-if="$slots.icon"
        class="flex items-center justify-center pl-3 relative top-[1.5px] text-primary"
      >
        <slot name="icon" />
      </div>
      <div class="pr-7 pl-4 text-left" :class="classes">
        <slot />
      </div>
    </slot>
  </div>
</template>

<script setup lang="ts">
defineProps({
  active: {
    type: Boolean,
    default: false,
  },
  classes: {
    type: String,
    default: "",
  },
});
</script>
